import React from 'react';
import { Box, Typography } from '@mui/material';

interface TimeListSectionProps {
  text: string;
}

export const TimeListSection = ({
  text,
}: TimeListSectionProps) => {
  return (
    <Box>
      <Box sx={{
        display: 'flex',
        marginTop: '2px',
      }}>
        <Typography sx={{
          color: '#1F1F1F',
          fontWeight: '700',
          fontSize: '12px',
        }}>
          {text}
        </Typography>
      </Box>
    </Box>
  );
};
